import axiosInstance from './AxiosInstance';

const API_URL = 'awardceremonies';

export const getAwardceremony = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching awardceremony', error);
        throw error;
    }
};

export const getAwardceremonyById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching awardceremony with id ${id}`, error);
        throw error;
    }
};

export const createAwardceremony = async (awardceremony) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, awardceremony);
        return response.data;
    } catch (error) {
        console.error('Error creating awardceremony', error);
        throw error;
    }
};

export const updateAwardceremony = async (id, awardceremony) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...awardceremony });
        return response.data;
    } catch (error) {
        console.error(`Error updating awardceremony with id ${id}`, error);
        throw error;
    }
};

export const deleteAwardceremony = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting awardceremony with id ${id}`, error);
        throw error;
    }
};

